import React, { useState } from "react";
import { Form, Select } from "antd";

function DropDown({
  form,
  name,
  label,
  width,
  required,
  labelColSpan,
  multiSelect,
  errorMessage,
  validateFunction,
  defaultValue,
  searchable,
  placeholder,
  options,
  disabled,
  includeAll,
}) {
  const [newO, setNewO] = useState(null);

  React.useEffect(() => {
    let newOpt = [];
    if (includeAll) {
      newOpt.push({ label: "All", value: "All" });
    }

    newOpt = [...newOpt, ...options];

    console.log(newOpt);

    setNewO(newOpt);

    if (defaultValue) {
      newOpt.forEach((d, i) => {
        if (d["value"] === defaultValue) {
          form.setFieldsValue({ [name]: d["value"] });
        }
      });
    }
  }, []);

  return (
    <Form.Item
      name={name}
      label={label}
      labelAlign={"left"}
      // labelCol={{ span: labelColSpan ? labelColSpan : 8 }}
      labelCol={labelColSpan ? labelColSpan : null}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },

        () => ({
          validator(rule, value) {
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      {newO ? (
        <Select
          disabled={disabled}
          mode={multiSelect ? "multiple" : null}
          defaultValue={defaultValue ? defaultValue : null}
          showSearch={searchable}
          placeholder={placeholder}
          style={{ fontWeight: 600 }}
          defaultActiveFirstOption
        >
          {newO.map((opt, index) => {
            return (
              <Select.Option value={opt.value} key={index}>
                {opt.label}
              </Select.Option>
            );
          })}
        </Select>
      ) : (
        <></>
      )}
    </Form.Item>
  );
}

export default DropDown;
